module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('h1', {
    staticClass: "f2 lh-copy pt3"
  }, [_vm._v("College Mentor")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid-third mv4"
  }, [_c('a', {
    staticClass: "no-underline",
    attrs: {
      "href": "mailto:campus-mentor@akkocollegecoverage.com"
    }
  }, [_c('ak-tile', {
    attrs: {
      "header": "Email",
      "subheader": "Send us a message",
      "classlist": "hover-lift"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "no-underline",
    attrs: {
      "href": _vm.isMobile ? 'http://m.me/AKKOCollegeCoverage' : 'https://www.facebook.com/messages/t/AKKOcollegecoverage',
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('ak-tile', {
    attrs: {
      "header": "Chat",
      "subheader": "Chat with us on Facebook",
      "classlist": "hover-lift"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "no-underline",
    attrs: {
      "href": "https://akkocollegecoverage.setmore.com",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('ak-tile', {
    attrs: {
      "header": "Schedule",
      "subheader": "1-on-1 Appointment with a mentor",
      "classlist": "hover-lift"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt4"
  }, [_c('div', {
    staticClass: "mb4 f3"
  }, [_vm._v("\n      Ask for advice. Discuss any concerns.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e202e622","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MentorPage.vue
// module id = 1531
// module chunks = 0